module.exports = __webpack_public_path__ + "img/Our_Inn_Place@1x.9bf34989.png";